import { z } from "zod";
import { EDisbursementMethod } from "../workers-shared/EDisbursementMethod";
import {
  EContractorPaymentStatus,
  EContractorPaymentType,
} from "../contractor-payments";

const getContractorsGrossPaySchema = z.object({
  mode: z.enum(["test", "live"]),
  currentYear: z.string().optional(),
  status: z.array(z.nativeEnum(EContractorPaymentStatus)),
  disbursement: z.nativeEnum(EDisbursementMethod).optional(),
  type: z.nativeEnum(EContractorPaymentType).optional(),
  date: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  amount: z.coerce.number().optional(),
  amountFrom: z.coerce.number().optional(),
  amountTo: z.coerce.number().optional(),
});

export type TGetContractorsGrossPayQuery = z.infer<
  typeof getContractorsGrossPaySchema
>;

const getContractorsGrossPayResponseData = z.object({
  totalAmount: z.number(),
});

export type TGetContractorsGrossPayResponseData = z.infer<
  typeof getContractorsGrossPayResponseData
>;
